/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs';
const componentName = 'vip-list-popover';
const prefix = `${moduleName}.${componentName}`;

export const headerPrefix = `${prefix}.headerPrefix`;

export const ENGLISH = {
    [headerPrefix]: 'Addresses {0} ({1})',
};
